import { p as proxyCustomElement, H, c as createEvent, h } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchValue, d as watchError, e as watchWarning, f as renderFormField } from './p-Cg8AdZPK.js';
import { t as toValue } from './p-CPuegN2k.js';
import { g as getFlatLavOptions, a as getCheckedAllStatus, H as HiddenHTMLSelect } from './p-BYoISW3Y.js';
import { d as defineCustomElement$b } from './p-BbTg3Car.js';
import { d as defineCustomElement$a } from './p-DhNzpZvu.js';
import { d as defineCustomElement$9 } from './p-DgmKwGNG.js';
import { d as defineCustomElement$8 } from './p-DSewpLF8.js';
import { d as defineCustomElement$7 } from './p-BlW2joRF.js';
import { d as defineCustomElement$6 } from './p-Dr61d_nc.js';
import { d as defineCustomElement$5 } from './p-D-dZjG8L.js';
import { d as defineCustomElement$4 } from './p-DT9iU5If.js';
import { d as defineCustomElement$3 } from './p-_P4kPR3l.js';
import { d as defineCustomElement$2 } from './p-CdhcNtiX.js';

const checkInputPanelCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.inner{border:1px solid var(--jw-theme-form-border-regular-default-border-color);border-radius:.375rem;display:flex;flex-direction:column;height:100%;width:100%}.header{background-color:var(--jw-theme-surface-elevated-default-bg-color);border-bottom:1px solid var(--jw-theme-surface-divider-color);border-top-left-radius:.375rem;border-top-right-radius:.375rem;padding:.75rem 1rem}.body{background-color:var(--jw-theme-surface-level1-default-bg-color);border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem;max-height:25.25rem;overflow-y:auto;padding:1rem}";

const WuiCheckInputPanel$1 = /*@__PURE__*/ proxyCustomElement(class WuiCheckInputPanel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        //////// FORM FIELD END ////////
        /**
         * Options
         */
        this.options = [];
        /**
         * If disabled
         */
        this.disabled = false;
        this.handleCheckAllInput = () => {
            if (this.checkedAllStatus === 'every') {
                this.setValue([]);
            }
            else {
                this.setValue(getFlatLavOptions(this.options).map((v) => toValue(v)));
            }
        };
    }
    _handleValueChange(newValue) {
        watchValue(this, newValue);
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    get checkedAllStatus() {
        return getCheckedAllStatus(this.options, this.value);
    }
    setValue(value) {
        this.value = value;
        this.dirty = true;
        this.checkValidity();
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    renderInner() {
        return (h("div", { class: "inner" }, h(HiddenHTMLSelect, { name: this.name, required: !!this.required, multiple: true, ref: this.setInputRef, disabled: this.disabled, options: this.options, value: this.value }), h("div", { class: "header" }, h("wui-check-input", { checked: this.checkedAllStatus === 'every', disabled: this.disabled || (this.options ?? []).length === 0, onInput: (e) => {
                // Stop the inner event from bubbling up
                e.stopPropagation();
                this.handleCheckAllInput();
            }, label: this.checkedAllStatus === 'every' ? 'Deselect all' : 'Select all', indeterminate: this.checkedAllStatus === 'some' })), h("div", { class: "body" }, h("wui-check-input-group", { options: this.options, value: this.value, onInput: (e) => {
                // We emit our own event
                e.stopPropagation();
                const target = e.currentTarget;
                if (!target) {
                    return;
                }
                this.setValue(target.value);
            }, disabled: this.disabled }))));
    }
    render() {
        return renderFormField(this, this.renderInner());
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return checkInputPanelCss; }
}, [257, "wui-check-input-panel", {
        "value": [1040],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "options": [16],
        "name": [1],
        "disabled": [4],
        "customValidation": [32],
        "showValidity": [32]
    }, undefined, {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-check-input-panel", "wui-box", "wui-button", "wui-check-input", "wui-check-input-group", "wui-form-field", "wui-icon", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-check-input-panel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCheckInputPanel$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-check-input-group":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiCheckInputPanel = WuiCheckInputPanel$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCheckInputPanel, defineCustomElement };
